import { PureComponent, ReactNode } from "react";

class UpRightIcon extends PureComponent {
  render(): ReactNode {
    return (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M19.75 11.25V4.25H12.75"
          stroke="#246DFF"
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M19.25 4.75L4.25 19.75"
          stroke="#246DFF"
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  }
}

export default UpRightIcon;
